// @ts-nocheck
import { useEffect, useRef, useState, Ref, useMemo, useCallback } from "react";
import { useNavigationStore } from "src/store/navigationStore";

import { GLB_AVATAR } from "src/const/navigationConst";

import { data_ifc } from "@/const/playground/data_ifc";
import { data_palace } from "@/const/playground/data_palace";
import { data_kowloon } from "@/const/playground/data_kowloon";
import { data_mPlus } from "@/const/playground/data_mPlus";

import { useModelViewerStore } from "@/store/modelViewerStore";
import { usePlaygroundStore } from "@/store/playgroundStore";

import {
  roundToDecimals,
  vec3Distance,
  hexToRgbArray,
  getYAngleDegree,
  angleDifferenceABtoAC,
  wrapAngle,
  calculateTargetPosition,
  normalizeRotation,
  interpolateVector3Array,
} from "src/utils/game";
import * as pc from "playcanvas";
import { OrbitControls } from "@playcanvas/react/scripts";
import {
  useTexture,
  useMaterial,
  useEnvAtlas,
  useApp,
  useSplat,
  useModel,
  useAppEvent,
} from "@playcanvas/react/hooks";
import { Application, Entity, Gltf, Modify } from "@playcanvas/react";
import {
  Anim,
  Render,
  Camera,
  Light,
  GSplat,
  Script,
  Environment,
  Collision,
  RigidBody,
} from "@playcanvas/react/components";
import { CameraControls } from "playcanvas/scripts/esm/camera-controls.mjs";

import WatermarkScreen from "src/components/watermark";
import { useLodSplat } from "src/utils/useLodSplat";
import LottieLoading from "src/components/lottie/lottie-loading";

import { GsplatRevealRadial } from "src/extra_js/reveal-radial.mjs";

import {
  createRadialScript,
  SplatSogComponent,
  installCameraNearFar,
  MeshModelComponent,
} from "@/components/playcanvas/playcanvasComponents";

const playgroundSourceData = {
  ifc: data_ifc,
  palace: data_palace,
  kowloon: data_kowloon,
  mPlus: data_mPlus,
};

const IS_AUTO_MODE = true;

export default function Playground() {
  const setAvatarPathProgress = usePlaygroundStore(
    (state) => state.setAvatarPathProgress,
  );

  const setIsShowJoystick = usePlaygroundStore(
    (state) => state.setIsShowJoystick,
  );

  // const interruptAutoPlay = useModelViewerStore(
  //   (state) => state.interruptAutoPlay,
  // );

  const setIsModelLoaded = usePlaygroundStore(
    (state) => state.setIsModelLoaded,
  );

  const startAutoPlayDelay = usePlaygroundStore(
    (state) => state.startAutoPlayDelay,
  );
  const stopAutoPlay = usePlaygroundStore((state) => state.stopAutoPlay);

  const moveSpeedRef = useRef<number>(2);
  const rotateSpeedRef = useRef<number>(20);

  // const defaultPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
  // const defaultTargetRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, -1));

  const [playgroundData, setPlaygroundData] = useState(null);

  const targetAltitudeRef = useRef<number>(0);

  const latestCurrentLevelNameRef = useRef<string>("");

  const mainObjectEntityRef = useRef();
  const cameraScriptRef = useRef();
  const firstPersonCameraEntityRef = useRef();
  const thirdPersonCameraEntityRef = useRef();
  const latestCameraModeRef = useRef<number>(0);

  const transitionTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(
    null,
  );

  const isMovingRef = useRef<boolean>(false);
  const isRotatingRef = useRef<boolean>(false);

  const latestPositionJoystickData = useRef<number[]>([0, 0]);
  const latestRotationJoystickData = useRef<number[]>([0, 0]);
  const latestRotationScreenData = useRef<number[]>([0, 0]);

  const latestResetPositionRotationEvent = useRef<number>(0);
  const latestResetOnlyRotationEvent = useRef<number>(0);

  const latestVenueModelConfigRef = useRef<VenueModelConfig | null>(null);

  const isInstantUpdate = useRef<boolean>(false);

  const latestModelJsonData = useRef<any>(null);

  const hiddenNearRef = useRef<pc.Entity>(null);
  const hiddenFarRef = useRef<pc.Entity>(null);

  const cameraArrayPosition = useRef([]);
  const cameraArrayTarget = useRef([]);

  const latestProgressRef = useRef(0);

  const AUTOPLAY_SPEED = 3;
  const autoPlaySpeedRef = useRef<number>(AUTOPLAY_SPEED);
  const isAutoPlayingRef = useRef<boolean>(false);
  const autoPlayTimeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const isPlayWalkingAnimationRef = useRef<boolean>(false);

  const eulerRef = useRef(new pc.Vec3(0, 0, 0));

  const isStartedRef = useRef(false);
  const isSplatReadyRef = useRef(false);
  const isMeshReadyRef = useRef(false);
  const isAvatarReadyRef = useRef(false);

  function stopAutoPlayFunction() {
    if (autoPlayTimeoutRef.current) {
      clearTimeout(autoPlayTimeoutRef.current);
    }
    autoPlayTimeoutRef.current = null;
    isAutoPlayingRef.current = false;
  }
  function resumeAutoPlay(milliseconds: number) {
    if (milliseconds > 0) {
      stopAutoPlayFunction();
    }
    autoPlayTimeoutRef.current = setTimeout(() => {
      autoPlayTimeoutRef.current = null;
      isAutoPlayingRef.current = true;
    }, milliseconds);
  }

  useEffect(() => {
    setIsModelLoaded(false);
  }, []);

  function useQueryParams() {
    return useMemo(() => new URLSearchParams(window.location.search), []);
  }

  const DataController = () => {
    const positionJoystickData = usePlaygroundStore(
      (state) => state.positionJoystickData,
    );
    const rotationJoystickData = usePlaygroundStore(
      (state) => state.rotationJoystickData,
    );

    useEffect(() => {
      latestPositionJoystickData.current = [
        positionJoystickData[0],
        positionJoystickData[1],
      ];
      //console.log("updated position");
      //console.log(latestPositionJoystickData.current);
      if (positionJoystickData[0] == 0 && positionJoystickData[1] == 0) {
        isPlayWalkingAnimationRef.current = false;
      } else {
        isPlayWalkingAnimationRef.current = true;
      }
    }, [positionJoystickData]);

    useEffect(() => {
      latestRotationJoystickData.current = [
        rotationJoystickData[0],
        rotationJoystickData[1],
      ];
    }, [rotationJoystickData]);

    const avatarPathProgress = usePlaygroundStore(
      (state) => state.avatarPathProgress,
    );

    useEffect(() => {
      latestProgressRef.current = avatarPathProgress;
    }, [avatarPathProgress]);

    const startAutoPlayData = usePlaygroundStore(
      (state) => state.startAutoPlayData,
    );
    useEffect(() => {
      if (startAutoPlayData.time > 0) {
        // setProgress(0);
        resumeAutoPlay(startAutoPlayData.delay);
      }
    }, [startAutoPlayData]);

    const stopAutoPlayData = usePlaygroundStore(
      (state) => state.stopAutoPlayData,
    );
    useEffect(() => {
      stopAutoPlayFunction();
    }, [stopAutoPlayData]);

    return <></>;
  };

  const MainCamera = () => {
    const app = useApp();
    const cameraRef = useRef();
    let _localProgress;
    let _localCameraMode;
    let isCameraModeUpdated;
    let nearestFixedCameraPosition;

    let finalCameraPosition;
    let finalCameraLookingPosition;

    app.on("update", function (dt) {
      if (cameraScriptRef.current == null) {
        return;
      }

      isCameraModeUpdated = _localCameraMode != latestCameraModeRef.current;
      _localCameraMode = latestCameraModeRef.current;

      if (
        isInstantUpdate.current ||
        isCameraModeUpdated ||
        isMovingRef.current ||
        isRotatingRef.current
      ) {
        const newPosition =
          latestCameraModeRef.current == 0
            ? firstPersonCameraEntityRef.current.getPosition()
            : thirdPersonCameraEntityRef.current.getPosition();
        cameraScriptRef.current.reset(
          mainObjectEntityRef.current.getPosition(),
          newPosition,
        );

        isMovingRef.current = false;
        isRotatingRef.current = false;
        isInstantUpdate.current = false;
      }
    });

    useEffect(() => {
      // const defaultCameraLookingPosition = new pc.Vec3(0, 0, -1);
      // const defaultPosition = new pc.Vec3(0, 0.5, 0);
      // cameraScriptRef.current.reset(
      //   defaultCameraLookingPosition,
      //   defaultPosition,
      // );
      cameraScriptRef.current._camera.gammaCorrection = 1;
      cameraScriptRef.current._camera.toneMapping = 0;
      //cameraScriptRef.current._camera.toneMapping = pc.TONEMAP_ACES2;
      cameraScriptRef.current._camera.jitter = 0;
      cameraScriptRef.current._camera.shutter = 0;
    }, []);

    app.on("update", function (dt) {
      if (cameraScriptRef.current == null) {
        return;
      }
    });

    return (
      <Entity name="MainCamera">
        <Camera fov={75} clearColor="#000000" clearColorBuffer={true} />
        <Script
          ref={cameraScriptRef}
          script={CameraControls}
          enableFly={false}
        />
        <Entity ref={hiddenNearRef} position={[0, 0, 0]}></Entity>
        <Entity ref={hiddenFarRef} position={[0, 0, -0.5]}></Entity>
      </Entity>
    );
  };

  const setPositionTarget = (
    positionX: number,
    positionY: number,
    positionZ: number,
    targetX: number,
    targetY: number,
    targetZ: number,
  ) => {
    const newPosition = new pc.Vec3(-positionX, positionY, -positionZ);
    const newTarget = new pc.Vec3(-targetX, targetY, -targetZ);
    if (mainObjectEntityRef.current) {
      mainObjectEntityRef.current.setPosition(newPosition);
      mainObjectEntityRef.current.lookAt(newTarget);
      const initAngles = mainObjectEntityRef.current.getEulerAngles();
      if (initAngles.z < 90 && initAngles.z > -90) {
        eulerRef.current.set(initAngles.x, initAngles.y, 0);
      } else if (initAngles.z > 90 || initAngles.z < -90) {
        if (initAngles.x > 0) {
          eulerRef.current.set(initAngles.x - 180, 180 - initAngles.y, 0);
        } else {
          eulerRef.current.set(initAngles.x + 180, 180 - initAngles.y, 0);
        }
      } else {
        eulerRef.current.set(0, 0, 0);
      }
      isInstantUpdate.current = true;
    }
  };

  const MainObject = () => {
    const app = useApp();
    const defaultPositionRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, 0));
    const defaultTargetRef = useRef<pc.Vec3>(new pc.Vec3(0, 0, -1));

    let _localResetPositionRotationEvent = 0;
    let _localResetOnlyRotationEvent = 0;
    let _localLeaveVenueEvent = 0;

    useEffect(() => {
      setPositionTarget(
        playgroundData.camera.position.x,
        playgroundData.camera.position.y,
        playgroundData.camera.position.z,
        playgroundData.camera.target.x,
        playgroundData.camera.target.y,
        playgroundData.camera.target.z,
      );
    }, []);

    app.on("update", function (dt) {
      if (mainObjectEntityRef.current == null) {
        return;
      }
      let isResetPositionRotation =
        _localResetPositionRotationEvent !=
        latestResetPositionRotationEvent.current;
      _localResetPositionRotationEvent =
        latestResetPositionRotationEvent.current;

      let isResetOnlyRotation =
        _localResetOnlyRotationEvent != latestResetOnlyRotationEvent.current;
      _localResetOnlyRotationEvent = latestResetOnlyRotationEvent.current;

      // if (latestPositionJoystickData.current.length != 2) {
      //   return;
      // }

      // if (
      //   latestPositionJoystickData.current[0] != 0 ||
      //   latestPositionJoystickData.current[1] != 0
      // ) {
      //   //stopAutoPlay();
      //   isMovingRef.current = true;
      //   const worldMat = mainObjectEntityRef.current.getWorldTransform();
      //   const forward = new pc.Vec3(0, 0, -1);
      //   worldMat.transformVector(forward, forward);
      //   // forward.y = 0;
      //   forward.normalize();
      //   const up = pc.Vec3.UP.clone();
      //   const right = new pc.Vec3();
      //   right.cross(up, forward).normalize();
      //   const forwardScale =
      //     latestPositionJoystickData.current[1] * moveSpeedRef.current * -dt;
      //   const rightScale =
      //     latestPositionJoystickData.current[0] * moveSpeedRef.current * -dt;
      //   const forwardMove = forward.clone().mulScalar(forwardScale);
      //   const rightMove = right.clone().mulScalar(rightScale);
      //   const move = new pc.Vec3();
      //   move.add(forwardMove).add(rightMove);
      //   mainObjectEntityRef.current.translate(move);
      // }

      if (
        latestRotationJoystickData.current[0] != 0 ||
        latestRotationJoystickData.current[1] != 0
      ) {
        //stopAutoPlay();
        isRotatingRef.current = true;

        eulerRef.current.y +=
          -latestRotationJoystickData.current[0] * rotateSpeedRef.current * dt; // Yaw
        eulerRef.current.x +=
          -latestRotationJoystickData.current[1] * rotateSpeedRef.current * dt; // Pitch

        eulerRef.current.x = pc.math.clamp(eulerRef.current.x, -45, 45);
        eulerRef.current.y = wrapAngle(eulerRef.current.y);
        mainObjectEntityRef.current.setLocalEulerAngles(eulerRef.current);
      }

      if (
        latestRotationScreenData.current[0] != 0 ||
        latestRotationScreenData.current[1] != 0
      ) {
        //stopAutoPlay();
        isRotatingRef.current = true;
        eulerRef.current.y +=
          -latestRotationScreenData.current[0] * rotateSpeedRef.current * dt; // Yaw
        eulerRef.current.x +=
          -latestRotationScreenData.current[1] * rotateSpeedRef.current * dt; // Pitch

        eulerRef.current.x = pc.math.clamp(eulerRef.current.x, -45, 45);
        eulerRef.current.y = wrapAngle(eulerRef.current.y);

        mainObjectEntityRef.current.setLocalEulerAngles(eulerRef.current);
      }
    });

    return (
      <Entity ref={mainObjectEntityRef}>
        {/*<Avatar />*/}
        <Entity
          ref={firstPersonCameraEntityRef}
          position={[0, 0, 0.001]}
        ></Entity>
        <Entity
          ref={thirdPersonCameraEntityRef}
          position={[0, 0.5, 4]}
        ></Entity>
      </Entity>
    );
  };

  const cleanup = (app, gsplatEntity) => {
    const cleanup = installCameraNearFar(
      app,
      gsplatEntity,
      hiddenNearRef.current,
      hiddenFarRef.current,
    );
    return cleanup;
  };

  const ModelSplat = () => {
    const app = useApp();
    const queryParams = useQueryParams();
    // let modelLink = queryParams.get("model");
    //modelLink = modelLink == null ? SAMPLE_MODEL : modelLink;
    let modelLink = playgroundData.splat;
    // const pathJsonLink = modelLink.replace(".sog", "_customPath.json");
    const callbackReadyFunction = (splat) => {
      setTimeout(() => {
        splat.gsplat.enabled = true;
        isSplatReadyRef.current = true;
      }, 100);
    };

    return (
      <SplatSogComponent
        app={app}
        url={modelLink}
        position={[0, 0, 0]}
        rotation={[180, 0, 0]}
        scale={[1, 1, 1]}
        callbackReady={callbackReadyFunction}
      />
    );
  };

  const PlaygroundMesh = () => {
    const app = useApp();
    const meshOpacity = 0;
    const meshEntityRef = useRef();
    const { asset: meshAsset } = useModel(playgroundData.mesh);

    const changeMaterial = (entity) => {
      if (entity == null) {
        return;
      }
      const renders = entity.findComponents("render");
      renders.forEach((render) => {
        if (render.meshInstances) {
          render.meshInstances.forEach((meshInstance) => {
            const material = meshInstance.material;
            if (material) {
              material.emissiveMap = material.diffuseMap;
              material.emissiveIntensity = 1;
              material.emissive = new pc.Color(1, 1, 1);
              material.useLighting = true;
              material.opacity = meshOpacity;
              material.blendType = pc.BLEND_NORMAL;
              material.depthWrite = false;
              // material.update();
              material.update();
            }
          });
        }
      });
    };

    const enableCollision = () => {
      if (meshEntityRef.current.collision) {
        meshEntityRef.current.collision.type = "mesh";
        meshEntityRef.current.collision.renderAsset =
          meshAsset.resource.renders[0];
        console.log(meshEntityRef.current.collision.renderAsset);
      } else {
        requestAnimationFrame(() => {
          enableCollision();
        });
      }
    };

    useEffect(() => {
      if (meshAsset && meshEntityRef.current) {
        requestAnimationFrame(() => {
          changeMaterial(meshEntityRef.current);
          enableCollision();
          isMeshReadyRef.current = true;
        });
      }
    }, [meshAsset]);
    return (
      <Entity
        ref={meshEntityRef}
        position={[0, 0, 0]}
        scale={[1, 1, 1]}
        rotation={[180, 0, 0]}
      >
        <RigidBody type="static" />
        <Render type="asset" asset={meshAsset} />
        {/*<Collision enabled={false} type="mesh" convexHull={false} />*/}
        <Collision type="box" convexHull={false} />
      </Entity>
    );
  };

  const PlayerAuto = () => {
    const app = useApp();
    const entityRef = useRef(null);
    const opacity = 0;
    const scale = playgroundData.scale;
    const speed = 1;
    const material = useMaterial({
      diffuse: "red",
      emissive: "red",
      emissiveIntensity: 1,
    });
    const isInitLookingPosition = useRef(false);
    const lookingPositionRef = useRef(new pc.Vec3(0, 0, 0));

    const positionRef = useRef(new pc.Vec3(0, 0, 0));
    const targetRef = useRef(new pc.Vec3(0, 0, 0));

    const isRecordingRef = useRef(false);
    const recordingPreviousPosition = useRef(new pc.Vec3(0, 0, 0));
    const recordingPositionArray = useRef([]);
    const recordingTargetArray = useRef([]);

    function setInitPosition() {
      console.log("Set position");
      positionRef.current.set(
        playgroundData.path.position[0][0],
        playgroundData.path.position[0][1],
        playgroundData.path.position[0][2],
      );
      targetRef.current.set(
        playgroundData.path.target[0][0],
        playgroundData.path.target[0][1],
        playgroundData.path.target[0][2],
      );
      entityRef.current.setPosition(positionRef.current);
      entityRef.current.lookAt(targetRef.current);
    }

    function autoPlayAvatar() {
      // console.log(latestProgressRef.current);
      const newPosition = interpolateVector3Array(
        playgroundData.path.position,
        latestProgressRef.current,
      );
      const newTarget = interpolateVector3Array(
        playgroundData.path.target,
        latestProgressRef.current,
      );
      positionRef.current.set(newPosition[0], newPosition[1], newPosition[2]);
      targetRef.current.set(newTarget[0], newTarget[1], newTarget[2]);
      entityRef.current.setPosition(positionRef.current);
      entityRef.current.lookAt(targetRef.current);
    }

    function onUpdate(dt) {
      const entity = entityRef.current;
      const camera = app.root.findByName("MainCamera");

      if (IS_AUTO_MODE) {
        autoPlayAvatar();
      } else {
        if (!entity?.rigidbody || !camera) return;

        if (!isInitLookingPosition.current) {
          isInitLookingPosition.current = true;
          const cameraPosition = camera.getPosition();
          lookingPositionRef.current = new pc.Vec3(
            cameraPosition.x + 1,
            0,
            cameraPosition.z,
          );
        }
        const [jx, jy] = latestPositionJoystickData.current;

        const move = new pc.Vec3();
        move.add(camera.right.clone().mulScalar(jx));
        move.add(camera.forward.clone().mulScalar(-jy));
        move.y = 0;
        if (move.lengthSq() > 0) {
          move.normalize().mulScalar(speed);
        }
        const v = entity.rigidbody.linearVelocity;
        v.x = move.x;
        v.z = move.z;
        entity.rigidbody.linearVelocity = v;
        if (move.lengthSq() > 0.0001) {
          lookingPositionRef.current = entity.getPosition().clone().add(move);
        }
        entity.lookAt(lookingPositionRef.current);

        if (isRecordingRef.current) {
          const newPosition = entity.getPosition();
          //console.log(vec3Distance(recordingPreviousPosition.current, newPosition));
          if (
            recordingPositionArray.current.length == 0 ||
            vec3Distance(recordingPreviousPosition.current, newPosition) > 0.3
          ) {
            recordingPreviousPosition.current.set(
              newPosition.x,
              newPosition.y,
              newPosition.z,
            );
            const newPositionRecording = [
              newPosition.x,
              newPosition.y,
              newPosition.z,
            ];
            const newTargetRecording = [
              lookingPositionRef.current.x,
              lookingPositionRef.current.y,
              lookingPositionRef.current.z,
            ];
            recordingPositionArray.current.push(newPositionRecording);
            recordingTargetArray.current.push(newTargetRecording);
            console.log("push new record");
            console.log(newPositionRecording);
          }
        }
      }
    }

    useEffect(() => {
      if (!IS_AUTO_MODE) {
        const handleSpacePress = (event: KeyboardEvent) => {
          if (event.key === "p") {
            console.log("start record");
            isRecordingRef.current = true;
            recordingPreviousPosition.current.set(0, 0, 0);
            recordingPositionArray.current = [];
            recordingTargetArray.current = [];
          }
          if (event.key === "o") {
            console.log("stop record");
            isRecordingRef.current = false;
            console.log(recordingPositionArray.current);
            console.log(recordingTargetArray.current);
          }
        };
        window.addEventListener("keydown", handleSpacePress);
        return () => {
          window.removeEventListener("keydown", handleSpacePress);
        };
      }
    }, []);

    useEffect(() => {
      material.opacity = opacity;
      material.blendType = pc.BLEND_NORMAL;
      material.depthWrite = false;
      material.update();
    }, [material]);

    useEffect(() => {
      setInitPosition();

      if (!IS_AUTO_MODE) {
        setTimeout(() => {
          console.log("fall");
          entityRef.current.addComponent("rigidbody", {
            friction: 0.5,
            mass: 1,
            linearDamping: 0,
            angularDamping: 1,
            type: "dynamic",
          });
        }, 1000);
      }
      app.on("update", onUpdate);

      return () => app.off("update", onUpdate);
    }, [app]);

    return (
      <Entity
        ref={entityRef}
        name="player"
        position={[0, 0, 0]}
        scale={[scale, scale, scale]}
      >
        <Robot />
        <Collision type="box" halfExtents={[scale / 2, scale / 2, scale / 2]} />
        <Render type="box" material={material} />
      </Entity>
    );
  };

  const Robot = () => {
    const app = useApp();
    const meshEntityRef = useRef();
    const isEnabledAnimationRef = useRef(false);
    const { asset: meshAsset } = useModel(playgroundData.avatar);

    const initAnimation = () => {
      if (meshEntityRef.current.anim.baseLayer) {
        console.log("animation ready!!");
        meshEntityRef.current.anim.baseLayer.transition("START");
      } else {
        requestAnimationFrame(() => {
          initAnimation();
        });
      }
    };

    const handleUpdate = useCallback((dt: number) => {
      if (!IS_AUTO_MODE) {
        if (
          meshEntityRef.current.anim.baseLayer == null ||
          isEnabledAnimationRef.current == false
        ) {
          return;
        }
        if (
          !isPlayWalkingAnimationRef.current &&
          meshEntityRef.current.anim.baseLayer.playing
        ) {
          meshEntityRef.current.anim.baseLayer.pause();
        } else if (
          isPlayWalkingAnimationRef.current &&
          !meshEntityRef.current.anim.baseLayer.playing
        ) {
          meshEntityRef.current.anim.baseLayer.playing = true;
        }
      }
    }, []);
    useAppEvent("update", handleUpdate);
    useEffect(() => {
      if (meshAsset && meshEntityRef.current) {
        const entity = meshEntityRef.current;
        requestAnimationFrame(() => {
          initAnimation();
          isAvatarReadyRef.current = true;
        });
        // meshEntityRef.current.anim.baseLayer.transition("START");
        // meshEntityRef.current.anim.baseLayer.pause();
        // isEnabledAnimationRef.current = true;
      }
    }, [meshAsset]);
    return (
      <Entity
        position={[0, 0.3, 0]}
        scale={[0.02, 0.02, 0.02]}
        rotation={[0, 180, 0]}
      >
        <Entity ref={meshEntityRef}>
          {/*<Render type="asset" asset={meshAsset} />*/}
          <Gltf asset={meshAsset} />
          <Anim asset={meshAsset} loop={true} activate={true} />
        </Entity>
      </Entity>
    );
  };

  const PlaycanvasScene = () => {
    const app = useApp();
    const queryParams = useQueryParams();
    let venue = queryParams.get("venue");

    useEffect(() => {
      const venueData =
        playgroundSourceData[venue] ?? playgroundSourceData["ifc"];
      setPlaygroundData(venueData);

      if (!IS_AUTO_MODE) {
        setIsShowJoystick(true);
      }
    }, []);

    app.scene.ambientLight.set(1, 1, 1);
    const newProgress = useRef(0);
    app.graphicsDevice.maxPixelRatio = 2;
    const handleUpdate = useCallback((dt: number) => {
      if (!isStartedRef.current) {
        if (
          isSplatReadyRef.current &&
          isMeshReadyRef.current &&
          isAvatarReadyRef.current
        ) {
          isStartedRef.current = true;
          setIsModelLoaded(true);
          if (IS_AUTO_MODE) {
            startAutoPlayDelay(500);
          }
        }
      }

      if (isAutoPlayingRef.current) {
        newProgress.current =
          latestProgressRef.current +
          (autoPlaySpeedRef.current / playgroundData.path.position.length) * dt;
        newProgress.current = newProgress.current > 1 ? 1 : newProgress.current;
        // console.log(newProgress);
        setAvatarPathProgress(newProgress.current);
        if (newProgress.current == 1) {
          setAvatarPathProgress(0);
        }
      }
    }, []);
    useAppEvent("update", handleUpdate);
    return (
      <>
        {playgroundData ? (
          <>
            <ModelSplat />
            <MainObject />
            <MainCamera />
            <PlaygroundMesh />
            <PlayerAuto />
          </>
        ) : (
          <></>
        )}
      </>
    );
  };

    const Ground = () => {
    const material = useMaterial({
      diffuse: "#FF0000",
      emissive: "#FF0000",
      emissiveIntensity: 1,
    });

    useEffect(() => {
      material.opacity = 1;
      material.blendType = pc.BLEND_NORMAL;
      material.update();
    }, [material]);

    return (
      <Entity name="ground" position={[0, -1, -1]} scale={[8, 0.1, 8]}>
        <RigidBody type="static" />
        <Collision type="box" halfExtents={[4, 0.05, 4]} />
        <Render type="box" material={material} />
      </Entity>
    );
  };

  const Scene = () => {
    return (
      <Application
        usePhysics={true}
        maxDeltaTime={0.033}
        graphicsDeviceOptions={{
          alpha: true,
          antialias: false,
          depth: true,
          stencil: false,
          powerPreference: "high-performance",
        }}
      >
        <PlaycanvasScene />
      </Application>
    );
  };

  const Loading = () => {
    const isModelLoaded = usePlaygroundStore((state) => state.isModelLoaded);
    return !isModelLoaded ? (
      <div className="frosted-fullscreen flex flex-col items-center justify-center">
        <LottieLoading />
      </div>
    ) : (
      <></>
    );
  };

  console.log(
    "Model Viewer Page component rendered , if this keep showing, something wrong",
  );

  const DragController = () => {
    const isDraggingRef = useRef(false);
    const startPosRef = useRef({ x: 0, y: 0 });
    const previousPositionRef = useRef({ x: 0, y: 0 });
    const getClientPos = (e) => {
      if (e.touches && e.touches.length > 0) {
        return { x: e.touches[0].clientX, y: e.touches[0].clientY };
      }
      return { x: e.clientX, y: e.clientY };
    };
    const handleStart = useCallback((e) => {
      const pos = getClientPos(e);
      isDraggingRef.current = true;
      previousPositionRef.current = { x: pos.x, y: pos.y };
    }, []);
    const handleMove = useCallback((e) => {
      if (!isDraggingRef.current) {
        return;
      }
      const pos = getClientPos(e);
      const xChange = pos.x - previousPositionRef.current.x;
      const yChange = pos.y - previousPositionRef.current.y;
      previousPositionRef.current = { x: pos.x, y: pos.y };
      latestRotationScreenData.current[0] = xChange * 0.5;
      latestRotationScreenData.current[1] = yChange * 0.5;
    }, []);
    const handleEnd = useCallback(() => {
      isDraggingRef.current = false;
      latestRotationScreenData.current[0] = 0;
      latestRotationScreenData.current[1] = 0;
    }, []);
    useEffect(() => {
      window.addEventListener("mouseup", handleEnd);
      window.addEventListener("touchend", handleEnd);
      return () => {
        window.removeEventListener("mouseup", handleEnd);
        window.removeEventListener("touchend", handleEnd);
      };
    }, []);

    return (
      <div
        className="fullscreen_div"
        onMouseDown={handleStart}
        onTouchStart={handleStart}
        onMouseMove={handleMove}
        onTouchMove={handleMove}
        onMouseUp={handleEnd}
        onTouchEnd={handleEnd}
      ></div>
    );
  };

  return (
    <div
      className="absolute top-0 left-0 w-full h-full"
      style={{ backgroundColor: "black" }}
    >
      <Loading />
      <DataController />
      <Scene />
      <DragController />
      <WatermarkScreen />
    </div>
  );
}
